module.exports = __webpack_public_path__ + "assets/img/quickStart-bg-finger.e7747073.png";